import { Step } from 'signup-constants/Step';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Tracker } from '../../store/tracking/action-creators';
import { ExperimentKeys } from '../ExperimentKeys';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isExperimentActive, getParameter } from '../../store/experiments/selectors';
import { trackExposure } from '../tracking/useShouldTrackExperiment';
export const setFlowForACQ155 = ({
  stepsToRemove = [],
  isPreVerificationExistingUserSession = false
}) => dispatch => {
  const {
    postExistingAccountSelection,
    postAccountCreation,
    preVerification,
    postVerification
  } = getFlowSteps();
  const acq155NextSteps = [...(isPreVerificationExistingUserSession ? [Step.ExistingUser] : []), ...(isPreVerification() ? preVerification : []), ...postVerification, ...postAccountCreation];
  const acq155FlowSteps = {
    acq155NextSteps,
    preVerification,
    postVerification,
    postAccountCreation,
    postExistingAccountSelection
  };
  if (stepsToRemove.length > 0) {
    // replicating the logic inside FlowStateManager.removeSteps(stepsToRemove)
    Object.keys(acq155FlowSteps).forEach(key => {
      acq155FlowSteps[key] = NextStepManager.removeSteps(...stepsToRemove)(acq155FlowSteps[key]);
    });
  }
  dispatch(setFlow(acq155FlowSteps.acq155NextSteps, acq155FlowSteps.preVerification, acq155FlowSteps.postVerification, acq155FlowSteps.postAccountCreation, acq155FlowSteps.postExistingAccountSelection));
  return acq155NextSteps;
};
export const setupAuthForOAuthExistingUserACQ155 = (state, experimentKey, dispatch) => {
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-variant_a`));
  dispatch(setFlowForACQ155({
    stepsToRemove: [Step.HubletSelection],
    isPreVerificationExistingUserSession: getIsAuthenticated(state) && isPreVerification()
  }));
};
export const trackACQ155ExposureForGooglePrompt = state => {
  const shouldTrackExposure = isExperimentActive(state, ExperimentKeys.ACQ0155);
  const parameter = getParameter(state, ExperimentKeys.ACQ0155);
  trackExposure(shouldTrackExposure, parameter, ExperimentKeys.ACQ0155);
};